// extracted by css-extract-rspack-plugin
export default {"cls1":"Header-cls1_zxi","cls2":"Header-cls2_XXO Header-cls1_zxi"};